export default "https://d1e6s5z4lzmgxx.cloudfront.net/6e52c691-29e3-4541-bed6-a97355993ecd/images/ob-step-2.png?5189a2dd4842bb72e8b01ea4bd86b2ed";